export enum UserPref {
	SESSION_DURATION = 'user.sessionDuration',
	PUBLIC_USER_LOGIN = 'viewer.userLogin',
	EMAIL_IMPORT_SETTING = 'email.asset.import',
	EMAIL_REVIEW_SETTING = 'email.asset.review',
}

export enum EmailFrequency {
	IMMEDIATE = 'immediately',
	DAILY = 'daily',
	NEVER = 'never',
}

/**
 * @deprecated Will be removed once new permissions system is fully adopted
 */
export enum UserLevel {
	BROWSER = 1,
	CONSUMER = 2,
	IMPORTER = 3,
	PRODUCER = 4,
	MANAGER = 7,
	DIRECTOR = 8,
	ADMIN = 9,
}

export enum UserPermission {
	READ = 1,
	DOWNLOAD = 2,
	ADD = 3,
	MODIFY = 5,
	DELETE = 7,
	ALL = 9,
}

export enum UserGroupItemType {
	GROUP = 'group',
	USER = 'user',
}

export enum UserImportOption {
	ADD_NEW_USERS_ONLY = 1,
	UPDATE_EXISTING_USERS_ONLY = 2,
	ADD_AND_UPDATE = 3,
	DELETE = 4,
}
